export const WITHDRAW_DEPOSIT_HISTORY_TABS = {
  all: {
    text: "All",
    value: "all",
    historyText: "Actions",
    id: 0,
  },
  deposit: {
    text: "Deposit",
    value: "deposit",
    historyText: "Deposit",
    id: 1,
  },
  withdraw: {
    text: "Withdraw",
    value: "withdraw",
    historyText: "Withdrawals",
    id: 2,
  },
};

export const WITHDRAW_DEPOSIT_STATES = {
  InProcessing: {
    name: "InProcessing",
    id: 1,
  },

  Confirmed: {
    name: "Confirmed",
    id: 2,
  },

  Canceled: {
    name: "Canceled",
    id: 3,
  },

  Corrected: {
    name: "Corrected",
    id: 4,
  },

  Corrector: {
    name: "Corrector",
    id: 5,
  },
};
